import React from 'react';
import { ReferenceField } from 'react-admin';

import FullNameField from '../components/FullNameField';

const ManagerReferenceField = props => {
  return (
    props.record.issue_manager ?
        <ReferenceField source="issue_manager.id" reference="users" {...props}>
            <FullNameField />
        </ReferenceField>
    : <>-</>
)};

ManagerReferenceField.defaultProps = {
    source: 'issue_manager.id',
    label: 'resources.issues.fields.issue_manager',
    addLabel: true,
};

export default ManagerReferenceField;
